var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWma = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 3.5C2.39431 3.5 0.973684 4.94367 0.973684 6.70259V15.2974C0.973684 17.0563 2.39431 18.5 4.16833 18.5H32.8317C34.6057 18.5 36.0263 17.0563 36.0263 15.2974V6.70259C36.0263 4.94368 34.6057 3.5 32.8317 3.5H4.16833ZM0 6.70259C0 4.37174 1.87589 2.5 4.16833 2.5H32.8317C35.1241 2.5 37 4.37174 37 6.70259V15.2974C37 17.6283 35.1241 19.5 32.8317 19.5H4.16833C1.87589 19.5 0 17.6283 0 15.2974V6.70259Z",
    fill: "#FF9908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5487 13.9936L15.1065 7.5H13.4208L12.5737 12.2034L11.4297 7.5H9.69633L8.55233 12.2034L7.71383 7.5H6L7.55783 13.9936H9.50783L10.5587 9.64868L11.5987 13.9936H13.5487Z",
    fill: "#FF9908"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2619 7.5453V13.9935H21.6802V9.96824L20.2784 14H18.9156L17.5051 9.9596V14H15.9277V7.55178H17.8539L19.6154 12.0435L21.3379 7.55178L23.2619 7.5453Z",
    fill: "#FF9908"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9439 12.808H28.3966L28.7844 13.9935H30.4614L28.0781 7.5453H26.2624L23.8791 13.9935H25.5366L25.9439 12.808ZM27.1789 9.22754L27.9914 11.6138H26.3599L27.1789 9.22754Z",
    fill: "#FF9908"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWma);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wma.290330edbfb1be1364700daea2a42158.svg";